module.exports = __webpack_public_path__ + "static/media/replay.56bb6798.svg";